<script setup>
import IconLogout from '~icons/svg/logout';
import { logout } from '@/api/logoutApi.js';
import { useRouter } from 'vue-router';
import { useNotificationStore } from '@/stores/notification.js';
import { MESSAGES } from '@/constants/messages';
// ストアを呼び出す
const store = useNotificationStore();
const router = useRouter();
const handleLogout = async () => {
  try {
    await logout();
    store.info(MESSAGES.INFO.LOGOUT);
    router.replace('/login');
  } catch (error) {
    console.error(error);
    store.error(MESSAGES.ERROR.AUTH);
  }
};
</script>
<template>
  <button
    class="ms-auto md:m-0 md:px-4 flex items-center cursor-pointer hover:text-emerald-600 hover:bg-emerald-100 rounded transition-colors duration-200"
    @click="handleLogout"
  >
    Logout
    <IconLogout class="ps-1 text-white hover:text-emerald-600" />
  </button>
</template>
